import { Component } from "react";
import "./TabsPanel.css";
import Logo from "../Logo";
import NavPanel from "../NavPanel/index";

export default class TabsPanel extends Component {
  render() {
    return (
      <div className="tabs-panel">
        <div>
          <Logo />
        </div>
        <NavPanel
          smallWindow={this.props.smallWindow}
          footer={this.props.footer}
          tabs={this.props.tabs}
          linkClassName={this.props.linkClassName}
        />
      </div>
    );
  }
}
